<template>
  <v-app id="mainApp" dark>
    <div>
      <v-img v-if="this.$root.loadFinish === 0"
        class="se-pre-con black"
        src="@/assets/preloader.gif"
        alt="Preload"
        position="center"
        contain
      ></v-img>
    </div>
    <template v-if="this.$root.loadFinish">
      <snackbar></snackbar>
      <Navigation v-if="!supervision" :isConnected="this.$root.isConnected" v-on:drawer.native="this.drawer"/>


      <v-main class="black">
        <template v-if="this.$root.isConnected && !supervision"><Breadcrumb layout-class="pl-3 py-3" /></template>
        <router-view></router-view>
      </v-main>
    </template>
  </v-app>
</template>

<script>
  import { mapActions,mapState,mapGetters } from 'vuex';
import Breadcrumb from './components/Breadcrumb';
import Snackbar from './components/Snackbar';
import NotificationMixin from './mixins/NotificationMixin';
import Navigation from './components/home/Navigation';

export default {
  mixins: [NotificationMixin],
  components: {
    Breadcrumb,
    Snackbar,
    Navigation,
  },
  data: () => ({
    timeLoad: 0,
    userProfil: null,
  }),
	methods: {
    ...mapActions({
      userGetData: 'user/data'
    }),
    completeTimeLoad() {
      var time = new Date().getTime();
      if ( (time - this.timeLoad) < 2000) {

        setTimeout(() => {  this.$root.loadFinish= 1; }, (2000 - (time - this.timeLoad)));
      } else {
        this.$root.loadFinish= 1;
      }
    }
  },
  beforeCreate: function(){
    console.log('beforeCreate');

  },
  created: function(){

    this.$root.loadFinish= 0;
    if (!this.$root.isConnected) {
      if(this.$route.name != 'RegenPassword') this.$router.push({ name: `Login` });
    } else {
      if (this.$root.passwordTurnover) {
        this.$router.push({ name: `PasswordTurnover` });
      }
    }
  },
  mounted: function(){
    this.timeLoad = new Date().getTime();
    this.userGetData({data: 'access'});
    if (! this.dataUser('profil')) {
      this.userGetData({data: 'profil'});
    } else {
      this.user = this.dataUser('profil');
    }
    //setTimeout(() => {  this.$root.loadFinish= 1; }, 2000);
  },
  computed: {
    ...mapState('user', {
      updatedata: 'updatedata',
      error: 'error',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    user: {
      get() { return this.userProfil },
       set(value) { this.userProfil = value; }
    },
    supervision() {
      if (this.user) {
        return this.user.supervision;
      }
      return false;
    }
  },
  watch: {
    error(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if(this.$route.name != 'RegenPassword' && this.$route.name != 'Login') this.$router.push({ name: `Login` });
        this.completeTimeLoad();
      }
    },
    updatedata: function (updatedata) {
      if (updatedata == 'access') {
        this.completeTimeLoad();
      }
      if (updatedata == 'profil') {
        this.user = this.dataUser('profil');
      }
    },
  }
};

</script>

<style>


/* Hide scrollbar for Chrome, Safari and Opera */
html::-webkit-scrollbar {
 display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
html {
 -ms-overflow-style: none;  /* IE and Edge */
 scrollbar-width: none;  /* Firefox */
}

a {
	text-decoration: none;
}
h1 > .v-icon {
	margin-right: 10px;
}
.toolbartitle_50  {
  max-width: 50%;
}

.routerLink {
  color: white!important;
}
.se-pre-con {
	position: fixed;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	z-index: 9999;
}
.cursorpointer {
  cursor: pointer;
}
</style>
